import { render, staticRenderFns } from "./TgsNewsDetail.vue?vue&type=template&id=585e97e0&"
import script from "./TgsNewsDetail.vue?vue&type=script&lang=js&"
export * from "./TgsNewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports